import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const ExclamationMark = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M11.9741751,3.51862503 C12.1260737,2.56825969 11.2146822,2 10.0248101,2 L9.97417724,2 C8.78531775,2 7.84759723,2.56825969 8.02582489,3.51862503 L9.61974724,12.6009825 C9.69454452,12.7366711 9.84054946,12.8214281 9.99949367,12.8214281 C10.1584379,12.8214281 10.3044428,12.7366711 10.3792401,12.6009825 L11.9741751,3.51862503 Z M11.9994915,16.1085164 C12.0158101,15.406996 11.6383185,14.7519008 11.0129623,14.3965035 C10.3876062,14.0411062 9.61239384,14.0411062 8.98703766,14.3965035 C8.36168148,14.7519008 7.98418986,15.406996 8.00050846,16.1085164 C8.02496708,17.1599685 8.91296632,18 10,18 C11.0870337,18 11.9750329,17.1599685 11.9994915,16.1085164 L11.9994915,16.1085164 Z"
				id="exclamationMark"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

ExclamationMark.propTypes = {
	color: PropTypes.string,
};

export default ExclamationMark;
